import { createSelector } from '@reduxjs/toolkit';
import {
  IViewPreferences,
  IDonationListPreferences,
  ISortState,
  IUserDates,
} from 'store/viewPreferences/types';
import { RootState } from 'store/create-store';

export const getViewPreferences = createSelector(
  [(state: RootState): IViewPreferences => state.viewPreferences],
  viewPreferences => viewPreferences
);

export const getUserDates = createSelector(
  [getViewPreferences],
  (state: IViewPreferences): IUserDates => state.dates
);

export const getDonationListPreferences = createSelector(
  [getViewPreferences],
  (state: IViewPreferences): IDonationListPreferences => state.donationListPreferences
);

export const getDonationListColumnVisibility = createSelector(
  [getDonationListPreferences],
  (state: IDonationListPreferences): Record<string, boolean> => state.columnVisibility ?? {}
);

export const getDonationListSortState = createSelector(
  [getDonationListPreferences],
  (state: IDonationListPreferences): ISortState =>
    state.sortState ?? { sortKey: null, reverse: null }
);

export const getDonationListSearchString = createSelector(
  [getDonationListPreferences],
  (state: IDonationListPreferences): string => state.searchString ?? ''
);

export const getRecipientDonationListPreferences = createSelector(
  [getViewPreferences],
  (state: IViewPreferences): IDonationListPreferences => state.recipientDonationListPreferences
);

export const getRecipientDonationListColumnVisibility = createSelector(
  [getRecipientDonationListPreferences],
  (state: IDonationListPreferences): Record<string, boolean> => state.columnVisibility ?? {}
);

export const getRecipientDonationListSortState = createSelector(
  [getRecipientDonationListPreferences],
  (state: IDonationListPreferences): ISortState =>
    state.sortState ?? { sortKey: null, reverse: null }
);

export const getRecipientDonationListSearchString = createSelector(
  [getRecipientDonationListPreferences],
  (state: IDonationListPreferences): string => state.searchString ?? ''
);
